module.exports = __webpack_public_path__ + "static/media/ArrowRight.cba2803b.svg";